import { useUser } from "@/zustand/store";
import { FC } from "react";

type BinCard = {
  id: number;
  name: string;
  image: string;
  price: number;
  bin: string;
  binValue: string;
};

type BinCardProp = {
  card: BinCard;
  className: string;
};

const BinCard: FC<BinCardProp> = ({ card, className }) => {
  const user = useUser();
  return (
    <>
      <div
        className={`group font-dm-sans h-[160px] max-w-70 min-w-68 overflow-hidden rounded-xl ${className}`}
        style={{
          background:
            "linear-gradient(108.57deg, #B9D2E2 -4.61%, #756C95 97.89%)",
        }}
      >
        <div className="group shadow-[rgba(0,_0,_0,_0.25)_0px_25px_50px_-12px]} relative h-full">
          {/* Background */}
          <div className="absolute inset-0 z-0">
            <img
              className="absolute inset-0 z-10 h-full w-full object-cover"
              src="/images/card-bg.svg"
            />
            <img
              className="absolute bottom-0 left-0"
              src="/images/bl-card-blur.svg"
            />
            <img
              className="absolute top-0 right-0"
              src="/images/tr-card-blur.svg"
            />
            <img
              className="absolute top-0 right-0 z-[1]"
              src="/images/card-lines.svg"
              alt=""
            />
          </div>

          <div className="relative z-10 flex h-2/3 flex-col justify-between px-4 pt-4">
            <div className="flex justify-between">
              <span className="text-xl font-bold text-white">
                {user.user.cardCreationFee} USD
              </span>
              <img
                src="/images/logo-transparent-light.svg"
                className="w-32"
                alt="logo"
              />
            </div>
            <div className="flex items-center justify-between">
              <span className="font-mont mt-4 text-xl font-bold text-white">
                {card?.bin}
              </span>
            </div>
          </div>
          <div className={`relative z-10 h-1/3 bg-transparent`}>
            <div className="flex h-full items-center justify-between px-4 pt-2">
              <div className="text-sm leading-6 text-white">
                <p className="font-mont text-white">Apple Pay / Google Pay</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BinCard;
